export var CRM_TYPES;
(function (CRM_TYPES) {
    CRM_TYPES["FIRST_NAME"] = "firstName";
    CRM_TYPES["LAST_NAME"] = "lastName";
    CRM_TYPES["EMAIL"] = "email";
    CRM_TYPES["PHONE"] = "phone";
    CRM_TYPES["ADDRESS"] = "address";
    CRM_TYPES["DATE"] = "date";
    CRM_TYPES["COMPANY"] = "company";
    CRM_TYPES["POSITION"] = "position";
    CRM_TYPES["WEBSITE"] = "website";
})(CRM_TYPES || (CRM_TYPES = {}));
export var CUSTOM_FIELD = 'customField';
export var CRM_TAGS;
(function (CRM_TAGS) {
    CRM_TAGS["OTHER"] = "other";
    CRM_TAGS["ANNIVERSARY"] = "anniversary";
    CRM_TAGS["MAIN"] = "main";
    CRM_TAGS["HOME"] = "home";
    CRM_TAGS["WORK"] = "work";
    CRM_TAGS["MOBILE"] = "mobile";
    CRM_TAGS["FAX"] = "fax";
    CRM_TAGS["BILLING"] = "billing-address";
    CRM_TAGS["SHIPPING"] = "shipping-address";
    CRM_TAGS["COMPANY"] = "company";
    CRM_TAGS["PERSONAL"] = "personal";
    CRM_TAGS["BIRTHDAY"] = "birthday";
})(CRM_TAGS || (CRM_TAGS = {}));
//# sourceMappingURL=crm-types-tags.js.map